import { LOCATION_DROPDOWN_STORAGE_KEYS } from "components/LocationDropdown/storageKeys";
import { APPOINTMENT_DETAILS_STORAGE_KEYS } from "modules/AppointmentDetails/storageKeys";
import { APPOINTMENTS_STORAGE_KEYS } from "modules/Appointments/storageKeys";
import { BACKORDERS_STORAGE_KEYS } from "modules/BackordersDashboard/storageKeys";
import { DAYPLANNER_STORAGE_KEYS } from "modules/Dayplanner/storageKeys";
import { DEALER_DOCUMENTATIONS_STORAGE_KEYS } from "modules/DealerDocumentations/storageKeys";
import { DEALERS_LICENSES_STORAGE_KEYS } from "modules/DealerLicenseOverview/storageKeys";
import { DEVICES_STORAGE_KEYS } from "modules/DevicesDashboard/storageKeys";
import { DMSV3_CUSTOM_QUERIES_STORAGE_KEYS } from "modules/DMSv3/CustomQueries/storageKeys";
import { EXACT_BILLING_STORAGE_KEYS, EXACT_MONITORING_STORAGE_KEYS } from "modules/ExactMonitoring/storageKeys";
import { INCOMPLETE_TYRES_STORAGE_KEYS } from "modules/IncompleteTyresDashboard/storageKeys";
import { LEADS_CARS_STORAGE_KEYS, LEADS_NOT_SNOOZED_STORAGE_KEYS, LEADS_SNOOZED_STORAGE_KEYS } from "modules/LeadsDashboard/storageKeys";
import { LOCATION_LICENSES_STORAGE_KEYS } from "modules/LocationLicenseOverview/storageKeys";
import { MANUFACTURER_STORAGE_KEYS } from "modules/ManufacturerDashboard/storageKeys";
import { THREE_DEPARTMENT_STORAGE_KEYS } from "modules/ThreeDepartmentDashboard/storageKeys";
import { TYRES_STORAGE_KEYS } from "modules/TyresDashboard/storageKeys";
import { UNLINKED_EXACT_LICENSES_STORAGE_KEYS } from "modules/UnlinkedExactLicensesDashboard/storageKeys";
import { USERS_DASHBOARD_STORAGE_KEYS } from "modules/UsersDashboard/storageKeys";
import { WARRANTY_STORAGE_KEYS } from "modules/WarrantyDashboard/storageKeys";

const clearStorageKeys = <T extends Record<string, string>>(storageEnum: T, exclude?: T[keyof T][]) => {
  Object.values(storageEnum).forEach(key => {
    if (!exclude?.includes(key as T[keyof T])) {
      localStorage.removeItem(key);
    }
  });
};

export const clearLocalStorageValues = () => {
  clearStorageKeys(DAYPLANNER_STORAGE_KEYS, [DAYPLANNER_STORAGE_KEYS.PinnedMechanicsPreference]);
  clearStorageKeys(LOCATION_LICENSES_STORAGE_KEYS);
  clearStorageKeys(APPOINTMENTS_STORAGE_KEYS, [APPOINTMENTS_STORAGE_KEYS.DateSortPreference, APPOINTMENTS_STORAGE_KEYS.MakePreference]);
  clearStorageKeys(APPOINTMENT_DETAILS_STORAGE_KEYS);
  clearStorageKeys(USERS_DASHBOARD_STORAGE_KEYS);
  clearStorageKeys(UNLINKED_EXACT_LICENSES_STORAGE_KEYS);
  clearStorageKeys(LOCATION_DROPDOWN_STORAGE_KEYS, [LOCATION_DROPDOWN_STORAGE_KEYS.AllLocationsSelectedPreference]);
  clearStorageKeys(DEALERS_LICENSES_STORAGE_KEYS);
};

export const clearDashboardFiltersValues = () => {
  clearStorageKeys(WARRANTY_STORAGE_KEYS);
  clearStorageKeys(MANUFACTURER_STORAGE_KEYS);
  clearStorageKeys(LEADS_SNOOZED_STORAGE_KEYS);
  clearStorageKeys(LEADS_NOT_SNOOZED_STORAGE_KEYS);
  clearStorageKeys(LEADS_CARS_STORAGE_KEYS);
  clearStorageKeys(BACKORDERS_STORAGE_KEYS);
  clearStorageKeys(THREE_DEPARTMENT_STORAGE_KEYS);
  clearStorageKeys(DEALER_DOCUMENTATIONS_STORAGE_KEYS);
  clearStorageKeys(DEVICES_STORAGE_KEYS);
  clearStorageKeys(DMSV3_CUSTOM_QUERIES_STORAGE_KEYS);
  clearStorageKeys(EXACT_MONITORING_STORAGE_KEYS);
  clearStorageKeys(EXACT_BILLING_STORAGE_KEYS);
  clearStorageKeys(INCOMPLETE_TYRES_STORAGE_KEYS);
  clearStorageKeys(TYRES_STORAGE_KEYS);
};
